import { render, staticRenderFns } from "./MessageMediaItemStatus.vue?vue&type=template&id=519d6ba5&scoped=true&"
import script from "./MessageMediaItemStatus.vue?vue&type=script&lang=ts&"
export * from "./MessageMediaItemStatus.vue?vue&type=script&lang=ts&"
import style0 from "./MessageMediaItemStatus.vue?vue&type=style&index=0&id=519d6ba5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519d6ba5",
  null
  
)

export default component.exports